const productionHostnames = [
    'dynamicdefense.att.com',
    'dynamicdefense.it.att.com',
    'mydynamicdefense.att.com'
];

const stageHostnames = [
    'dynamicdefense.stage.att.com',
    'dynamicdefense-stage.att.com',
    'dynamicdefense-c-stage.att.com'
];

const demoHostname = 'dynamicdefense-demo.dev.att.com';

const stageAndProdHostnames = [...productionHostnames, ...stageHostnames, demoHostname];

export const envKnowledgeBaseLink =
    stageAndProdHostnames.includes(window.location.hostname) ? 'https://kb-dynamicdefense.att.com/attdd/docs' :
        'https://dynamicdefense-cms-fe.dev.att.com/attdd/docs';

export const envBusinessCenterDomain =
    productionHostnames.includes(window.location.hostname) ?
        'businesscenter.att.com' : 'test5-businesscenter.att.com';

export const isDemoEnv = () =>
    window.CONFIG.ENVIRONMENT_NAME === 'DEMO';